import { ArrowRight } from "lucide-react";

export const CTASection = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-[2.5rem] bg-slate-900 overflow-hidden p-10 md:p-16 lg:p-20 text-center">
          <div className="absolute -top-40 -right-40 h-[420px] w-[420px] rounded-full bg-orange-500/25 blur-3xl" />
          <div className="absolute -bottom-40 -left-40 h-[420px] w-[420px] rounded-full bg-teal-500/25 blur-3xl" />

          <div className="relative">
            <span className="text-xs tracking-[0.22em] uppercase font-semibold text-orange-400">
              Ready to go digital?
            </span>
            <h2
              data-testid="final-cta-headline"
              className="font-heading mt-4 text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl mx-auto leading-tight"
            >
              Throw away the diary.{" "}
              <span className="text-orange-400">Pick up the app.</span>
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto">
              Join thousands of Indian businesses who manage credit, invoices and
              inventory the smart way — with Reptile Hisabbook.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#pricing"
                data-testid="final-cta-primary"
                className="inline-flex items-center gap-2 rounded-full bg-orange-500 hover:bg-orange-600 px-8 py-4 text-base font-semibold text-white shadow-xl shadow-orange-500/30 hover:shadow-2xl hover:shadow-orange-500/40 transition-all active:scale-95"
              >
                Choose Your Plan
                <ArrowRight className="h-4 w-4" />
              </a>
              <a
                href="#contact"
                data-testid="final-cta-secondary"
                className="inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/15 backdrop-blur-sm border border-white/20 px-7 py-4 text-base font-semibold text-white transition-all active:scale-95"
              >
                Talk to Sales
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
